module.exports = __webpack_public_path__ + "img/no_list.103cb469.png";